<template>
  <div>
    <HeaderCampaignCoupons ref="header" :id="id" :channels-list="channelsList" @refresh="loadCoupons" />
    <ListCampaignCoupons
      :id="id"
      :coupons="coupons"
      :loading="loading"
      @refresh="loadCoupons"
      @edit="openEditDialog"
    />
  </div>
</template>

<script>
import AdvertiserService from '../../services/AdvertiserService';
import CampaignMixin from '../../mixins/CampaignMixin';
import HeaderCampaignCoupons from './HeaderCampaignCoupons.vue';
import ListCampaignCoupons from './ListCampaignCoupons.vue';

export default {
  name: 'CampaignCoupons',
  mixins: [AdvertiserService, CampaignMixin],
  components: {
    HeaderCampaignCoupons,
    ListCampaignCoupons
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      coupons: [],
      channelsList: [],
      loading: false
    };
  },
  methods: {
    async loadCoupons() {
      this.loading = true;
      try {
        const { data, status } = await this.listCampaignCoupons(this.id);
        if (status === 200) {
          this.coupons = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500) {
          this.errorNotify(this.$t('problem_try_again_later'));
        } else {
          this.errorNotify(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async loadChannels() {
      try {
        const { data, status } = await this.listSiteApprovedDetailsByCampaign(this.id);
        if (status === 200 || status === 201) {
          this.channelsList = data.map((item) => ({
            ...item,
            site_name: `${item.site_name} (ID: ${item.site_id})`
          }));
        }
      } catch (error) {
        if (error.response && error.response.status === 500) {
          this.errorNotify(this.$t('problem_try_again_later'));
        }
      }
    },

    openEditDialog(coupon) {
      this.$refs.header.openEditDialog(coupon);
    }
  },

  created() {
    this.loadChannels();
    this.loadCoupons();
  }
};
</script>
